export var Status;
(function (Status) {
    Status["UNKNOWN"] = "UNKNOWN";
    /** The reservation is held for 10 minutes, during which time the reservee should fill in their details. */
    Status["HELD"] = "HELD";
    /** The reservation has been reserved. */
    Status["RESERVED"] = "RESERVED";
    /** The reservation has been canceled. */
    Status["CANCELED"] = "CANCELED";
    /** The reservation has finished successfully. */
    Status["FINISHED"] = "FINISHED";
    /** The reservee didn't arrive. */
    Status["NO_SHOW"] = "NO_SHOW";
    /** The reservee occupied the table. */
    Status["SEATED"] = "SEATED";
    /** The reservee requested a reservation and is waiting for manual approval. */
    Status["REQUESTED"] = "REQUESTED";
    /** The owner declined a reservee's request. */
    Status["DECLINED"] = "DECLINED";
})(Status || (Status = {}));
export var Source;
(function (Source) {
    Source["UNKNOWN"] = "UNKNOWN";
    /** The reservation is created by a User. */
    Source["OFFLINE"] = "OFFLINE";
    /** The reservation is created by UoU. */
    Source["ONLINE"] = "ONLINE";
    /** The reservation is created by a User. It can be created without reservee data. */
    Source["WALK_IN"] = "WALK_IN";
})(Source || (Source = {}));
export var TableCombinationConflictType;
(function (TableCombinationConflictType) {
    TableCombinationConflictType["UNKNOWN"] = "UNKNOWN";
    TableCombinationConflictType["RESERVED"] = "RESERVED";
    TableCombinationConflictType["TOO_BIG"] = "TOO_BIG";
    TableCombinationConflictType["TOO_SMALL"] = "TOO_SMALL";
    TableCombinationConflictType["OFFLINE_ONLY"] = "OFFLINE_ONLY";
})(TableCombinationConflictType || (TableCombinationConflictType = {}));
export var Type;
(function (Type) {
    Type["UNKNOWN"] = "UNKNOWN";
    Type["PARTY_PACING"] = "PARTY_PACING";
    Type["SEAT_PACING"] = "SEAT_PACING";
})(Type || (Type = {}));
export var Set;
(function (Set) {
    Set["PUBLIC"] = "PUBLIC";
    Set["FULL"] = "FULL";
})(Set || (Set = {}));
export var SortOrder;
(function (SortOrder) {
    SortOrder["ASC"] = "ASC";
    SortOrder["DESC"] = "DESC";
})(SortOrder || (SortOrder = {}));
//# sourceMappingURL=types.impl.js.map